<form *ngIf="reportUserGroupPermissionFormGroup" [formGroup]="reportUserGroupPermissionFormGroup">
    
        <div class="grid">
            <div class="col-12 input-field" *ngIf="type=='USER'">
                <label for="userId">Usuario</label>                
                <p-dropdown [options]="usersGroups" formControlName="userId" optionValue="id" [filter]="true" filterBy="name" (onFilter)="loadUsers($event)"
                    optionLabel="name" placeholder="Seleccione usuario" d-form-field-error  appendTo="body" />
            </div>
            <div class="col-12 input-field" *ngIf="type=='GROUP'">
                <label for="userId">Grupo</label>                
                <p-dropdown [options]="usersGroups" formControlName="groupId" optionValue="id" [filter]="true" filterBy="name"
                    optionLabel="name" placeholder="Seleccione grupo" d-form-field-error  appendTo="body" />
            </div>
            <div class="col-6 input-field">
                <label for="allowRead">Lectura</label>
                <p-inputSwitch formControlName="allowRead" d-form-field-error></p-inputSwitch>
            </div>  
            <div class="col-6 input-field">
                <label for="allowWrite">Escritura</label>
                <p-inputSwitch formControlName="allowWrite" d-form-field-error></p-inputSwitch>
            </div>  
        </div>

        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete && reportUserGroupPermission.id" icon="pi pi-trash"
                styleClass="p-button-danger" (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    

</form>